import * as types from "./types";

const mutations = {
    [types.LOADING_PROJECT](state, value) {
        state.loading = value;
    },
    [types.GET_PROJECT_LIST](state, projects) {
        state.projects = projects;
    },
    [types.REMOVE_PROJECT](state, id) {        
        state.projects = state.projects.filter((x) => x.projectId !== id);        
    },
    [types.ADD_PROJECT](state, projects) {        
        state.projects.unshift(projects);
    },
    [types.UPDATE_PROJECT](state, projects) {        
        const ProjectIndex = state.projects.findIndex((x) => x.projectId === projects.projectId);
        state.projects[ProjectIndex] = projects;        
    },

    [types.GET_PROJECT_ID](state, project) {
        state.projectId = project;
    },

    [types.GET_PROJECT_TASK](state, tasks) {
        state.tasks = tasks;
    },
    [types.ADD_PROJECT_TASK](state, tasks) {
        state.tasks.unshift(tasks);
    },
    [types.REMOVE_PROJECT_TASK](state, id) {
        state.tasks = state.tasks.filter((x) => x.id !== id);
    },
    [types.UPDATE_PROJECT_TASK](state, tasks) {
        const TaskIndex = state.tasks.findIndex((x) => x.id === tasks.id);
        state.tasks[TaskIndex] = tasks;
    },

    [types.GET_PROJECT_ASSIGNEES](state, assignees) {
        state.assignees = assignees;
    },

    [types.GET_PROJECT_MILESTONE](state, milestones) {
        state.milestones = milestones;
    },
    
    [types.ADD_PROJECT_MILESTONE](state, milestones) {
        state.milestones.unshift(milestones);
    },

    [types.REMOVE_PROJECT_MILESTONE](state, id) {
        state.milestones = state.milestones.filter((x) => x.id !== id);
    },

    [types.UPDATE_PROJECT_MILESTONE](state, milestones) {
        const MilestoneIndex = state.milestones.findIndex((x) => x.id === milestones.id);
        state.milestones[MilestoneIndex] = milestones;
    },

    [types.GET_PROJECT_SUBTASK](state, subtasks) {
        state.subtasks = subtasks;
    },
    [types.ADD_PROJECT_SUBTASK](state, subtasks) {
        state.subtasks.unshift(subtasks);
    },
    [types.REMOVE_PROJECT_SUBTASK](state, id) {
        state.subtasks = state.subtasks.filter((x) => x.id !== id);
    },
    [types.UPDATE_PROJECT_SUBTASK](state, subtasks) {
        const TaskIndex = state.subtasks.findIndex((x) => x.id === subtasks.id);
        state.subtasks[TaskIndex] = subtasks;
    },
};


export default mutations;